<style lang="scss">
@media screen and (min-width: 55rem) {
  .membershipbannercard-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;

    .membershipbannercard {
      max-width: 1080px;
      width: 80%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;
      height: 25rem;
      margin-top: 5rem;

      .membershipbannercard-top {
        width: 100%;
        height: 10rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .membershipbannercard-top-subtitle {
          font-size: 1rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .membershipbannercard-top-title {
          font-size: 2rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: bold;
          color: #4b4b4b;
        }
        .membershipbannercard-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .membershipopeningmethodcontent {
        margin-top: 5rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 90%;
        height: 10rem;
        font-family: "PingFang SC", "Microsoft YaHei";
        color: #7f7f7f;
        font-size: 1.3125rem;
        font-weight: 400;
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .membershipbannercard-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    margin-top: 2rem;

    .membershipbannercard {
      width: 80%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;

      .membershipbannercard-top {
        width: 100%;
        height: 10rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .membershipbannercard-top-subtitle {
          font-size: 1rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .membershipbannercard-top-title {
          font-size: 2rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: bold;
          color: #4b4b4b;
        }
        .membershipbannercard-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .membershipopeningmethodcontent {
        margin-top: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 90%;
        font-family: "PingFang SC", "Microsoft YaHei";
        color: #7f7f7f;
        font-size: 1.3125rem;
        font-weight: 400;
      }
    }
  }
}
</style>

<template>
  <div class="membershipbannercard-container">
    <div class="membershipbannercard">
      <div class="membershipbannercard-top">
        <div class="membershipbannercard-top-subtitle">Card opening method</div>
        <div class="membershipbannercard-top-title">开通方法</div>
        <div class="membershipbannercard-top-line"></div>
      </div>
      <div class="membershipopeningmethodcontent">
        该权益由会员支付365元在喵街APP上购买，自购买之日起有效期365天。有效期内，在开通该项权益的所有银泰门店及喵街APP均可在常规折扣及商场活动基础上再享受折上9折优惠
        (黄金珠宝等特殊商品除外)。
      </div>
      <br>
      <img src="/media/yintai/membershipcard-1.png" width="96px" height="96px">
      <p>扫码开通<br>INTIME365</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "membershipbannercard",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
